var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-static"},[_c('div',{staticClass:"warning-static__ico"},[_c('WarningIco')],1),_c('div',{staticClass:"warning-static__info"},[_c('div',{staticClass:"warning-static__title"},[_vm._t("title")],2),_c('div',{staticClass:"warning-static__text"},[_vm._t("text")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }